module.exports = __webpack_public_path__ + "img/gb2671.prt.79cba164.jpg";